import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { PracticalExample } from '@/services/content'
import { Check, Lightbulb } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SectorPracticalExamplesSectionProps {
  examples?: PracticalExample[]
}

export const SectorPracticalExamplesSection = ({
  examples,
}: SectorPracticalExamplesSectionProps) => {
  if (!examples || examples.length === 0) return null

  return (
    <section className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="container px-4 md:px-6">
        <ScrollReveal className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100 text-yellow-600 mb-6">
            <Lightbulb className="w-6 h-6" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
            Exemplos Práticos
          </h2>
          <p className="text-slate-600 mt-4 text-lg max-w-2xl mx-auto">
            Aplicações concretas das nossas soluções no dia-a-dia das empresas
            deste setor.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {examples.map((example, idx) => (
            <ScrollReveal key={idx} delay={idx * 100}>
              <div
                className={cn(
                  'flex gap-5 p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300',
                  'group hover:border-primary/20',
                )}
              >
                <div className="mt-1 flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                    <Check className="w-5 h-5 text-green-600 group-hover:text-primary transition-colors" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-primary transition-colors">
                    {example.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {example.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
